import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import React from 'react';
import { InfoDot } from './info-dot';
import { DocumentType } from 'models/jobs/jobs';
export const IDConstraintsSection = ({ info, label, onChange, value }) => {
    const update = (index, updates) => {
        onChange(value.map((c, i) => (i === index ? { ...c, ...updates } : c)));
    };
    const remove = (index) => {
        onChange(value.filter((_, i) => i !== index));
    };
    const add = () => {
        onChange([...value, {}]);
    };
    return (React.createElement(Grid, { item: true, style: { marginTop: 8 }, xs: 12 },
        React.createElement(Typography, { style: {
                alignItems: 'center',
                display: 'flex',
                gap: 4,
                marginBottom: 4
            }, variant: "body2" },
            label,
            info && React.createElement(InfoDot, { info: info })),
        value.map((rule, idx) => (React.createElement(Grid, { alignItems: "center", container: true, item: true, 
            // eslint-disable-next-line react/no-array-index-key
            key: idx, spacing: 1, style: { marginBottom: 4 } },
            React.createElement(Grid, { item: true, xs: 4 },
                React.createElement(TextField, { fullWidth: true, inputProps: {
                        maxLength: 2,
                        style: { textTransform: 'uppercase' }
                    }, label: "Country (2-char)", onChange: (e) => {
                        update(idx, { country: e.target.value.toUpperCase() });
                    }, size: "small", value: rule.country ?? '' })),
            React.createElement(Grid, { item: true, xs: 5 },
                React.createElement(FormControl, { fullWidth: true, size: "small" },
                    React.createElement(InputLabel, null, "Document Type"),
                    React.createElement(Select, { onChange: (e) => {
                            update(idx, { type: String(e.target.value) });
                        }, value: rule.type ?? '' },
                        React.createElement(MenuItem, { value: "" },
                            React.createElement("em", null, "Any")),
                        Object.values(DocumentType).map((dt) => (React.createElement(MenuItem, { key: dt, value: dt }, dt)))))),
            React.createElement(Grid, { item: true, xs: 3 },
                React.createElement(Button, { onClick: () => {
                        remove(idx);
                    }, size: "small" }, "Remove"))))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Button, { onClick: add, size: "small", variant: "outlined" }, "+ Add Rule"))));
};
